// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "FeaturedInModule-module--arrow-up-and-down--7558e";
export var card = "FeaturedInModule-module--card--34bf4";
export var cardsContainer = "FeaturedInModule-module--cardsContainer--ba142";
export var contentContainer = "FeaturedInModule-module--contentContainer--f0c17";
export var link = "FeaturedInModule-module--link--e0b0e";